@if (data && data.length) {
  @for (location of data; track location) {
    @if (markers && markers.length) {
      <map
        type="markers"
        [options]="options"
        [markers]="markers"
        (mapLoaded)="mapLoaded()"
      ></map>
    }
    @if (!location.fieldEventLocation && location.fieldAddress) {
      <h2>
        {{ location?.fieldBuildingName || ('school.legal_address' | translate)
        }}
      </h2>
      <p>{{ location?.fieldAddress }}</p>
    }
    @if (location.fieldEventMainDate) {
      <h2>{{ 'event.place_and_time' | translate }}</h2>
      @if (location.fieldEventMainDate) {
        <p>
          <span>
            {{ 'time.'+ (location.fieldEventMainDate | weekday: "unix" |
            lowercase) | translate }} {{ location.fieldEventMainDate | date:
            "dd.MM yyy "}}
            @if (location.fieldEventStartTimeMain && location.fieldEventEndTimeMain) {
              <span
                >
                <span> {{ 'time.time_of_day' | translate }}</span>
                @if (location.fieldEventStartTimeMain) {
                  {{ location.fieldEventStartTimeMain | unixToTime }}
                }
                @if (location.fieldEventStartTimeMain && location.fieldEventEndTimeMain) {
                  -
                }
                @if (location.fieldEventEndTimeMain) {
                  {{ location.fieldEventEndTimeMain | unixToTime }}
                }
              </span>
            }
          </span>
          @if (location && location.fieldEventDate) {
            @for (item of location.fieldEventDate; track item) {
              <div>
                @if (item.fieldEventAdditionalDate) {
                  {{ 'time.'+ (item.fieldEventAdditionalDate | weekday: "unix" |
                  lowercase) | translate }} {{ item.fieldEventAdditionalDate | date:
                  "dd.MM yyy "}}
                  @if (item.fieldEventStartTimeAddition || item.fieldEventEndTimeAddition) {
                    <span>
                      <span> {{ 'time.time_of_day' | translate }}</span>
                      @if (item.fieldEventStartTimeAddition) {
                        {{ item.fieldEventStartTimeAddition | unixToTime }}
                      }
                      @if (item.fieldEventStartTimeAddition && item.fieldEventEndTimeAddition) {
                        -
                      }
                      @if (item.fieldEventEndTimeAddition) {
                        {{ item.fieldEventEndTimeAddition | unixToTime }}
                      }
                    </span>
                  }
                }
              </div>
            }
          }
        </p>
      }
      <p>
        @if (location.fieldEventLocation) {
          {{ location.fieldEventLocation?.name }}<br />
        }
        @if (location.fieldEventLocationLink?.length) {
          <a
            href="{{ location.fieldEventLocationLink?.[0]?.uri }}"
            target="_blank"
            >{{ location.fieldEventLocationLink?.[0]?.uri }}</a
            >
          }
        </p>
      }
    }
  }
